<template>
  <modal v-if="isVisible">
    <template v-slot:header>
      <h5 class="modal-title">{{$t(title)}}</h5>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="close">
        <span aria-hidden="true">
          <img src="@/assets/img/static/b-icon_close_x.svg">
        </span>
      </button>
    </template>

    <template v-slot:body>
      <slot name="body">
        <div>
          <p>{{$t(text)}}</p>
          <div class="a-width-100-percent a-color-red text-center" v-if="warn">{{$t(warn)}}</div>
        </div>
      </slot>
    </template>

    <template v-slot:footer>
      <button class="gui-btn gui-btn--white-border gui-btn--ep" @click.prevent="handleCancel" v-t="'buttons.cancel'"></button>
      <button class="gui-btn gui-btn--red gui-btn--ep" @click.prevent="handleConfirm" v-t="'buttons.confirm'"></button>
    </template>
  </modal>
</template>

<script>
  export default {
    props: {
      closeOnAction: {
        type: Boolean,
        default: false
      }
    },

    data: () => ({
      isVisible: false,
      title: undefined,
      text: undefined,
      warn: undefined
    }),

    methods: {
      open({title, text, warn, onConfirm, onCancel}) {
        this.title = title;
        this.text = text;
        this.warn = warn;
        this.isVisible = true;
        this.onConfirm = onConfirm || (() => {});
        this.onCancel = onCancel || (() => {});
      },

      close() {
        this.isVisible = false;
        this.$emit('close');
      },

      handleConfirm() {
        this.onConfirm();
        this.$emit('confirm');

        if (this.closeOnAction) {
          this.close();
        }
      },

      handleCancel() {
        this.onCancel();
        this.$emit('cancel');

        if (this.closeOnAction) {
          this.close();
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
